/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "./type";
/**
 * @hidden
 */
var DataSourceDataCommittedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataSourceDataCommittedEventArgs, _super);
    function DataSourceDataCommittedEventArgs(a, b) {
        var _this = _super.call(this) || this;
        _this._commitID = 0;
        _this._changes = null;
        _this.commitID = a;
        _this.changes = b;
        return _this;
    }
    Object.defineProperty(DataSourceDataCommittedEventArgs.prototype, "commitID", {
        get: function () {
            return this._commitID;
        },
        set: function (a) {
            this._commitID = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataSourceDataCommittedEventArgs.prototype, "changes", {
        get: function () {
            return this._changes;
        },
        set: function (a) {
            this._changes = a;
        },
        enumerable: true,
        configurable: true
    });
    DataSourceDataCommittedEventArgs.$t = markType(DataSourceDataCommittedEventArgs, 'DataSourceDataCommittedEventArgs', EventArgs.$);
    return DataSourceDataCommittedEventArgs;
}(EventArgs));
export { DataSourceDataCommittedEventArgs };
//# sourceMappingURL=DataSourceDataCommittedEventArgs.js.map
